import { render, staticRenderFns } from "./AsideMenu.vue?vue&type=template&id=0f22fb3f&scoped=true"
import script from "./AsideMenu.vue?vue&type=script&lang=js"
export * from "./AsideMenu.vue?vue&type=script&lang=js"
import style0 from "./AsideMenu.vue?vue&type=style&index=0&id=0f22fb3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.38_css-loader@7.1.4_@rspack+core@1.6.4_webpack_852858acfdff260959c5a19d045c9569/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f22fb3f",
  null
  
)

export default component.exports